import { OrderPaymethods } from "@/entities/api/orders/orders"

export function PaymethodsConvert(method: OrderPaymethods): string {
	switch (method) {
		case OrderPaymethods.card:
			return 'Tarjeta de crédito/débito'
		case OrderPaymethods.pse:
			return 'PSE'
		case OrderPaymethods.nequi:
			return 'Nequi'
		case OrderPaymethods.cash:
			return 'Efectivo'
		case OrderPaymethods.bancolombia_transfer:
			return 'Transferencia Bancolombia'
		case OrderPaymethods.daviplata:
			return 'Daviplata'
		case OrderPaymethods.payment_on_delivery:
			return 'Pago contra entrega'
		case OrderPaymethods.none:
			return 'Sin método de pago'
		default:
			return 'Método desconocido'
	}
}